module.exports = __webpack_public_path__ + "img/bad_smell.964c755d.svg";